import { render, staticRenderFns } from "./AddInvoiceItemPage.vue?vue&type=template&id=bf783f58&"
import script from "./AddInvoiceItemPage.vue?vue&type=script&lang=js&"
export * from "./AddInvoiceItemPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports